'use client';

import Link from 'next/link';
import {
  Instagram,
  Facebook,
  Linkedin,
  Youtube,
  Sparkles,
  Paintbrush2,
  Ruler,
  Lightbulb,
} from 'lucide-react';

export default function ComingSoonPage() {
  return (
    <div className="pt-32 pb-32 flex flex-col items-center justify-start min-h-screen bg-[#0e0e0e] text-white px-4 text-center">

      {/* GRAND INTRO */}
      <h1 className="text-5xl md:text-7xl py-2 font-bold bg-gradient-to-r from-[#d4af37] via-white to-[#d4af37] bg-clip-text text-transparent mb-6 drop-shadow-lg leading-tight">
        A New Era of Interiors & Real Estate by Solusi Design
      </h1>

      <p className="text-lg md:text-xl text-gray-300 max-w-3xl mb-10">
        We're launching something extraordinary. From elegant "home interiors" to full-scale "real estate ventures", Solusi Design is expanding its vision.
      </p>


      {/* Highlights Cards */}
      <div className="mt-24 grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl w-full px-4">
        {[
          {
            icon: <Sparkles className="text-[#d4af37] w-8 h-8 mr-4" />,
            title: 'Timeless Interiors',
            text: 'Custom-designed living spaces that blend beauty and functionality.',
          },
          {
            icon: <Paintbrush2 className="text-[#d4af37] w-8 h-8 mr-4" />,
            title: 'Signature Aesthetics',
            text: 'A fusion of modern elegance with timeless appeal in every project.',
          },
          {
            icon: <Ruler className="text-[#d4af37] w-8 h-8 mr-4" />,
            title: 'Space Optimization',
            text: 'Architectural planning that maximizes utility and style.',
          },
          {
            icon: <Lightbulb className="text-[#d4af37] w-8 h-8 mr-4" />,
            title: 'Innovative Thinking',
            text: 'Transforming spaces with forward-thinking interior and real estate solutions.',
          },
        ].map(({ icon, title, text }) => (
          <div
            key={title}
            className="flex items-start p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 shadow-md hover:shadow-[0_0_30px_#d4af37aa] transition-all"
          >
            {icon}
            <div className="text-left">
              <h3 className="text-xl font-semibold text-[#d4af37] mb-1">{title}</h3>
              <p className="text-gray-300 text-sm">{text}</p>
            </div>
          </div>
        ))}
      </div>
{/* Redesigned Social Media Links */}
<div className="flex flex-wrap justify-center items-center gap-12 mt-24 text-sm text-gray-400">
  {[
    {
      href: 'https://www.instagram.com/solusidesigns/',
      label: 'Instagram',
      icon: <Instagram className="w-5 h-5 mr-2" />,
    },
    {
      href: 'https://www.facebook.com/solusidesigns',
      label: 'Facebook',
      icon: <Facebook className="w-5 h-5 mr-2" />,
    },
    {
      href: 'https://www.linkedin.com/company/solusi-designs/',
      label: 'LinkedIn',
      icon: <Linkedin className="w-5 h-5 mr-2" />,
    },
    {
      href: '#',
      label: 'YouTube',
      icon: <Youtube className="w-5 h-5 mr-2" />,
    },
  ].map((item) => (
    <Link
      key={item.label}
      href={item.href}
      target="_blank"
      className="flex items-center hover:text-[#d4af37] transition-all "
    >
      {item.icon}
      <span>{item.label}</span>
    </Link>
  ))}
</div>

 
    </div>
  );
}
